class ArticleHeader
    constructor: (el) ->
        @.$el = el
        @.$readingTimeEl = @.$el.querySelector '.article-header__reading-time__time'

        @.InitEvents()
        @.$el.classList.add 'article-header--bound'
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'article-header-set-reading-time', (e) ->
            readingTime = e.detail?.readingTime ? false
            if readingTime
                self.$readingTimeEl.textContent = readingTime
                self.$el.classList.add 'article-header--rt-set'
            return
        return

BindArticleHeaders = ->
    document.querySelectorAll '.article-header:not(.article-header--bound)'
        .forEach (el) ->
            new ArticleHeader el
            return
    return

window.addEventListener 'bind-components', BindArticleHeaders